import axios from 'axios';
import React, { useState } from 'react';

const ApplicationForm = ({onClose}) => {
  const [applicationName, setApplicationName] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    
    const requestData = {
        applicationName: applicationName // Ensure this exists
    };

    console.log("Submitting data:", requestData); // Debugging log

    try {
        const response = await axios.post("http://localhost:4000/applicationpost", requestData);
        console.log("Response:", response.data);
        onClose()
    } catch (error) {
        console.error("Error creating role:", error);
    }
};


  return (
    <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create Application</h5>
            <button type="button" className="btn-close"  onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form id="formAuthentication" className="mb-3 p-2" onSubmit={onSubmit}>
              <div className="mb-2">
                <label htmlFor="applicationName" className="form-label">
                  Application Name <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="applicationName"
                  value={applicationName}
                  onChange={(e) => setApplicationName(e.target.value)}
                  placeholder="Enter Application Name"
                  autoFocus
                  required
                />
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationForm;
